import React from "react";
import cookies from "js-cookie";
import actionCookie from "../../../../helpers/action-cookie";
import ListCustomers from "./ListCustomers";

function GroupPublisher() {
  cookies.set(
    actionCookie.PREVIOUS_PAGE,
    actionCookie.PREVIOUS_PAGE_VALUE_ALL_PUBLISHERS
  );

  return (
    <>
      <div
        className="tab-pane fade border border-3 p-2 rounded"
        id="group-publisher"
        role="tabpanel"
        aria-labelledby="group-publisher-tab"
      >
        <ListCustomers />
      </div>
    </>
  );
}

export default GroupPublisher;
